import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import { Typography } from 'beam/dist/Typography'
import BeamIcon from 'beam/dist/BeamIcon'
import Tooltip from 'beam/dist/Tooltip'
import EvaluationAnswer from './EvaluationAnswer'
import { EVAL_STATE, ANSWER_TYPE } from './evaluationForm.constants'
import useEvaluationFormStyles from './EvaluationForm.styles'
import { difference } from '../../../Common/Utils'

const propTypes = {
  questionTemplate: PropTypes.object,
  questionValues: PropTypes.object,
  isPercentageScoreType: PropTypes.bool,
  evaluationState: PropTypes.number,
  comments: PropTypes.array,
  sectionIndex: PropTypes.number,
  questionIndex: PropTypes.number,
  sectionId: PropTypes.number,
  renderComments: PropTypes.func,
  onAnswerClick: PropTypes.func,
}

const EvaluationQuestion = ({
  questionTemplate,
  questionValues,
  isPercentageScoreType,
  evaluationState,
  comments,
  sectionIndex,
  questionIndex,
  sectionId,
  renderComments,
  onAnswerClick,
}) => {
  const classes = useEvaluationFormStyles()
  const { t } = useTranslation()

  return (
    <div key={questionTemplate.id} className={classes.question}>
      <Typography variant="body2">
        {`${sectionIndex + 1}.${questionIndex + 1} ${questionTemplate.text}`}{' '}
        {isPercentageScoreType && (
          <span className={classes.questionWeight}>{Number.parseFloat(questionTemplate.weight * 100).toFixed(2)}%</span>
        )}
        {(questionTemplate.description && questionTemplate.description !== '') && (
          <Tooltip
            title={questionTemplate.description}
            placement='bottom'
            PopperProps={{
              disablePortal: true,
            }}
            classes={{ popper: classes.inlinePopper }}
            arrow>
            <span className={classes.descriptionContainer}>
              <BeamIcon className={classes.descriptionIcon}>Information</BeamIcon>
            </span>
          </Tooltip>
        )}
      </Typography>
      {[
        EVAL_STATE.SCORED,
        EVAL_STATE.NEEDS_APPROVAL,
        EVAL_STATE.CANNOT_SCORE,
        EVAL_STATE.NEEDS_CANNOT_SCORE_APPROVAL,
      ].indexOf(evaluationState) !== -1
        ? questionTemplate.options
          .filter(answer => answer.id === questionValues.selectedOption)
          .map(answer => (
            <Typography style={{ marginLeft: '16px' }} key={answer.id} variant="body1">
              {`${answer.label}`}
              {answer.type !== ANSWER_TYPE.NOT_APPLICABLE && (
                <span className={classes.answerPoints}>{`(${answer.points}${isPercentageScoreType ? '%' : ''})`}</span>
              )}
            </Typography>
          ))
        : questionTemplate.options.map(answer => (
          <EvaluationAnswer
            key={answer.id}
            answer={answer}
            isSelected={questionValues.selectedOption === answer.id}
            isPercentageScoreType={isPercentageScoreType}
            sectionId={sectionId}
            questionId={questionTemplate.id}
            onClick={onAnswerClick}
          />
        ))}
      {renderComments(
        comments,
        `evaluation-form-section-${sectionIndex + 1}-question-${questionIndex + 1}`,
        t('addAQuestionComment'),
        sectionId,
        questionTemplate.id,
      )}
    </div>
  )
}

EvaluationQuestion.propTypes = propTypes

export default memo(EvaluationQuestion, (prevProps, nextProps) => {
  const diff = difference(nextProps, prevProps)
  return isEmpty(diff)
})
